import { render, staticRenderFns } from "./ListCompanySetting.vue?vue&type=template&id=b107879c&scoped=true&"
import script from "./ListCompanySetting.vue?vue&type=script&lang=js&"
export * from "./ListCompanySetting.vue?vue&type=script&lang=js&"
import style0 from "./ListCompanySetting.vue?vue&type=style&index=0&id=b107879c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b107879c",
  null
  
)

export default component.exports